export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-57x57-682d9985c495b330f5771e1158061479.png";